import { State } from '@/store/store'

export class CaregiverState {
  public list: CaregiverList
  public byId: ICaregiver

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.byId = {
      _id: '',
      idCard: '',
      userId: '',
      patientTypeId: '',
      prefix: '',
      firstname: '',
      lastname: '',
      phone: '',
      sosPhone: '',
      drugAllergy: '',
      disease: '',
      hospital: '',
      birthdate: '',
      status: '',
      map: {
        lat: 0,
        lon: 0,
      },
      address: {
        address: '',
      },
      metadata: {},
    }
  }
}
export interface CaregiverList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id: string,
    name?: string,
    userId: string,
    idCard: string,
    profile?: string,
    prefix: string,
    firstname: string,
    lastname: string,
    map: {
      lat: number,
      lon: number,
    },
    address: {
      address: string,
      country?: string,
      district?: string,
      elevation?: number,
      geocode?: string,
      postcode?: string,
      province?: string,
      road?: string,
      road_lat?: number,
      road_lon?: number,
      subdistrict?: string,
    },
    phone?: string,
    sos_phone?: string,
    status: string,
    birthdate?: string,
    drugAllergy: string,
    desease: string,
    hospital: string,
    patientTypeId?: string,
    createdAt?: number,
    updatedAt?: number,
  }>
}
export interface ICaregiver {
  _id: string,
  idCard: string,
  userId: string,
  patientTypeId: string,
  prefix: string,
  firstname: string,
  lastname: string,
  phone: string,
  sosPhone: string,
  drugAllergy: string,
  disease: string,
  hospital: string,
  birthdate: string,
  status: string,
  map: {
    lat: number,
    lon: number,
  },
  address: {
    address: string,
    country?: string,
    district?: string,
    elevation?: number,
    geocode?: string,
    postcode?: string,
    province?: string,
    road?: string,
    road_lat?: number,
    road_lon?: number,
    subdistrict?: string,
  },
  metadata?: any,
}

export default CaregiverState
